export enum WageAndTravelCategory {
    ToDo = 0,
    PendDocs = 1,
    PendVerify = 2,
    PendSurgery = 3,
    PendWageReimburse = 4,
    PendTravelReceipts = 5,
    PendTravelReimbursement = 6,
    Reimbursed = 8,
    NotReimbursed = 9,
    Search = 10,
    YearEndReport = 11,
    Transactions = 12,
    AddRequest = 13,
    Donated = 14,
    PendingWageToDo = 15,
    PendingTravelToDo = 16,
    PendingPayment = 17,
    PendingLWRVerify = 18,
    PendingDERVerify = 19,
    PendingWire = 20,
    PaymentError = 21,
    PendRegistration = 22
}